//@flow
import React from 'react';

import {makeStyles, TableCell} from '@material-ui/core';
import CustomTextField from '../../../../../elements/CustomTextField/CustomTextField';
import {useProductContext} from '../../../context';
import {useEditProduct} from '../../../utils/editProduct';
import {debounce} from '../../../../../utils/functions';

const useStyles = makeStyles(theme => ({
  numberField: {
    width: '96px',
  },
}));

export default function ProductTaxedPriceCell() {
  const classes = useStyles();

  const [product, setProduct] = useProductContext(product => {
    const taxes = product.taxes ?? [];
    const categoryTaxes = product.categoryTaxes ?? [];

    return {
      id: product.id,
      price: product.price,
      enabledProductVariant: !!product.productVariantSetting?.enabled,
      hasVariants:
        product.productVariantSetting?.variants &&
        product.productVariantSetting?.variants.length > 0,
      taxes: [...taxes, ...categoryTaxes]
        .map(parseFloat)
        .reduce((a, b) => a + b, 1),
      taxedPrice: product.taxedPrice,
    };
  }, false);

  const {editProduct} = useEditProduct(product ? product.id : '');

  const hasVariants = product.enabledProductVariant && product.hasVariants;

  const handleChange = price => {
    const withoutTaxPrice = parseFloat(Number(price) / product.taxes).toFixed(
      5
    );
    setProduct({price: withoutTaxPrice, taxedPrice: price});
    debounce(_ => {
      if (!price) return;

      editProduct({price});
    }, 750)();
  };

  return (
    <TableCell align="right">
      <CustomTextField
        name="price"
        value={product.taxedPrice}
        className={classes.numberField}
        type="number"
        defaultValue={product.price}
        inputProps={{
          step: '0.01',
        }}
        disabled={hasVariants}
        onChange={e => handleChange(e.target.value)}
      />
    </TableCell>
  );
}
